<div class="map-toggle light-theme" [class.open-window]="this.showWindow">
    <div class="search-holder">
        <mat-tab-group mat-align-tabs="start">
            <mat-tab label="{{ 'PROJECTS_MAP' | translate }}">
                <ng-template mat-tab-label>
                    <mat-icon class="projects-map-icon"></mat-icon>
                    {{ 'PROJECTS_MAP' | translate }}
                </ng-template>
                <!-- <app-filtering (filteredProjects)="udateProjectList($event)"></app-filtering> -->
            </mat-tab>
            <mat-tab label="{{ 'LIST-OF-PROJECTS' | translate }}">
                <div class="search-panel-design">
                    <ng-template mat-tab-label>
                        <mat-icon class="projects-list-icon"></mat-icon>
                        {{ 'LIST-OF-PROJECTS' | translate }}
                    </ng-template>
                    <!-- <app-search-projects [showProperties]="true" [projects]="this.items"
                        class="search-panel-design"></app-search-projects> -->
                </div>
            </mat-tab>
            <!-- <mat-tab label="{{ 'PROJECTS-VISUAL-MAP' | translate }}" *ngIf="this.company?.visualMap">
                <div class="search-panel-design">
                    <ng-template mat-tab-label>
                        <mat-icon class="projects-list-icon"></mat-icon>
                        <span (click)="this.showVisualMapF()">{{ 'PROJECTS-VISUAL-MAP' | translate }}</span>
                    </ng-template>
                    <div *ngIf="this.company && showVisualMap">
                        <app-visual-map-with-proj-statistic *ngIf="this.company.visualMap" [showProperties]="true"
                            [projects]="this.items" [visualMap]="this.company.visualMap"
                            class="search-panel-design"></app-visual-map-with-proj-statistic>
                    </div>
                </div>
            </mat-tab> -->
        </mat-tab-group>



    </div>
    <!-- <a class="close-section" href="javascript:;" (click)="navigatToMainPage()"></a> -->
    <!-- <agm-map *ngIf="!routerUrl && this.translate.currentLang" [latitude]="+lat" [longitude]="+lng" [zoom]="+zoom" [styles]="this.styles" id="mapRef">
        <div *ngFor="let item of items">
            <agm-marker *ngIf="item.markerImage" (markerClick)="openPopUp(item, window);" [latitude]="+item.lat" [longitude]="+item.lng"
                [iconUrl]="item.markerImage" class="marker-holder">
                <agm-info-window #window [disableAutoPan]="true">
                    <div class="close-trigger close-btn" (click)="closeWindow()"></div>
                    <div class="window-top-holder">
                        <div class="logo-holder">
                            <app-gallery [galleryId]="'1'" [section]="compId + 'imagesCompLogo'" [autoPlay]="false"
                                [showThumbs]="false" class="logo-img-proj"></app-gallery>
                        </div>
                        <h5 class="proj-icon divide-border" (click)="goToPproject(item)">{{ item.title }}</h5>
                        <ul class="building-list">
                            <li *ngFor="let building of buildings" (click)="goToBuilding(building.uid, item)"><a
                                    href="javascript:;">{{ building.name }}</a></li>
                        </ul>
                    </div>
                    <div *ngIf="window.id() && this.infoWindow === window" class="col m12 iframe da-iframe"
                        [innerHtml]="item.spirical | safe: 'html'">
                    </div>
                </agm-info-window>
            </agm-marker>
            <agm-marker *ngIf="!item.markerImage" (markerClick)="openPopUp(item, window);" [latitude]="+item.lat" [longitude]="+item.lng"
            [iconUrl]="marker" class="marker-holder">

            <agm-info-window #window [disableAutoPan]="true">
                <div class="close-trigger close-btn" (click)="closeWindow()"></div>
                <div class="window-top-holder">
                    <div class="logo-holder">
                        <app-gallery [galleryId]="'1'" [section]="compId + 'imagesCompLogo'" [autoPlay]="false"
                            [showThumbs]="false" class="logo-img-proj"></app-gallery>
                    </div>
                    <h5 class="proj-icon divide-border" (click)="goToPproject(item)">{{ item.title }}</h5>
                    <ul class="building-list">
                        <li *ngFor="let building of buildings" (click)="goToBuilding(building.uid, item)"><a
                                href="javascript:;">{{ building.name }}</a></li>
                    </ul>
                </div>
                <div *ngIf="window.id() && this.infoWindow === window" class="col m12 iframe da-iframe"
                    [innerHtml]="item.spirical | safe: 'html'">
                </div>
            </agm-info-window>
        </agm-marker>
        </div>
    </agm-map> -->

    <!-- <div #gnmapContainer id="Nmap"></div> -->
    <div>
        <google-map #gnmapContainer class="my-google-map" [options]="{styles: this.styles, zoomControl: true}"
            [width]="mapWidth" [height]="mapHeight" [center]="{ lat: 32.0853, lng: 34.7818 }" [zoom]="8" id="Nmap">
            <!-- <div *ngFor="let marker_item of items; trackby marker_item"> -->
            <div *ngFor="let marker_item of items; trackBy: trackByFn">
                <map-marker #marker="mapMarker" class="marker-holder" [options]="marker_item.options"
                    (mapClick)="openPopUp(marker, marker_item,  infoWindow, $event)">
                </map-marker>


                <map-info-window #infoWindow >
                    <div class="close-trigger close-btn" (click)="closeWindow()"></div>
                    <div class="window-top-holder">
                        <div class="logo-holder">
                            <app-gallery [galleryId]="'1'" [section]="compId + 'imagesCompLogo'" [autoPlay]="false"
                                [showThumbs]="false" class="logo-img-proj"></app-gallery>
                        </div>
                        <h5 *ngIf="this.marker_item1" class="proj-icon divide-border"
                            (click)="goToPproject(this.marker_item1)">{{ this.marker_item1.title }} {{
                            this.marker_item.uid }} {{ this.projId }}
                        </h5>
                        <ul class="building-list">
                            <li *ngFor="let building of buildings"
                                (click)="goToBuilding(building.uid, this.marker_item1)">
                                <a href="javascript:;">{{ building.name }}</a>
                            </li>
                        </ul>
                    </div>
                    <!-- <div *ngIf="marker_item1 && marker_item1.id === marker_item.id" class="col m12 iframe da-iframe" [innerHtml]="this.marker_item1.spirical | safe: 'html'">
                    </div> -->
                    <div *ngIf="this.projId === marker_item1?.uid" class="col m12 iframe da-iframe"
                        [innerHtml]="marker_item1?.spirical | safe: 'html'">
                    </div>

                </map-info-window>
            </div>

        </google-map>
    </div>

</div>